import { RequestResponse, withAuthGuard as decorateWithAuthGuard } from '@dark-portal/react-infrastructure';
import { refreshRequest } from './refresh';
import { getIdentityConfig } from '../config';

type RequestMethod<TParams, TBody, TResult> = (params: any) => RequestResponse<TResult>;

export function withAuthGuard<TParams = undefined, TBody = undefined, TResult = void>(
  method: RequestMethod<TParams, TBody, TResult>,
): RequestMethod<TParams, TBody, TResult> {
  return decorateWithAuthGuard(method, {
    onRefresh: refreshRequest,
    onLogout: () => getIdentityConfig().onLogout(),
  });
}